import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleData } from '@/mocks/articles';

export default function ArticlePage() {
  const article = articleData['what-is-sugargoo-spreadsheet'];
  return <ArticleLayout article={article} />;
}